export default "__VITE_ASSET__AsNpTANA__";